// Utilisez une variable d'environnement pour l'URL du backend
// En production, cette variable sera définie lors du build
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

export const startEvaluation = async (file: File, lang: string = 'fr'): Promise<{ evaluationId: string }> => {
  const formData = new FormData();
  formData.append('media', file);
  formData.append('lang', lang);

  const response = await fetch(`${BACKEND_URL}/api/evaluate`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to start evaluation');
  }

  return await response.json();
};

export const getEvaluationResult = async (evaluationId: string): Promise<{
  prediction: number | null;
  prediction_list: Array<{ start: number; end: number; prediction: number }> | null;
  status: string;
}> => {
  const response = await fetch(`${BACKEND_URL}/api/evaluate/${evaluationId}/result`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to retrieve evaluation result');
  }

  return await response.json();
};

export interface TranscriptionResult {
  status: string;
  segments: Array<{ start: number; end: number; text: string }> | null;
}

export const getTranscription = async (evaluationId: string): Promise<TranscriptionResult> => {
  const response = await fetch(`${BACKEND_URL}/api/evaluate/${evaluationId}/transcription`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to retrieve transcription');
  }

  return await response.json();
};
